import type { NodeMembership } from 'models';
import type { User } from 'features/auth';
import { isSuperAdmin } from '../utils';

const personnelRoles = new Set([
  'admin',
  'callCenterCes',
  'navigator',
  'navigatorSupervisor',
  'patientNavigator',
  'patientNavigatorSupervisor',
  'provider',
]);
const medicalGroupAndCohort = new Set(['group.cohort', 'group.medicalGroup']);

const isMembershipPersonnel = (membership: NodeMembership) =>
  personnelRoles.has(membership.role) && medicalGroupAndCohort.has(membership.type);

export const canViewEhrPortal = ({ viewer: { nodeUserData, railsUserData } }: { viewer: User }) =>
  isSuperAdmin({ viewer: railsUserData }) ||
  Boolean(nodeUserData.memberships?.some((membership) => isMembershipPersonnel(membership)));
